const defaultApiBaseUrl = 'http://127.0.0.1:3000'

export function resolveApiBaseUrl() {
  const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL || defaultApiBaseUrl

  if (configuredBaseUrl.startsWith('http://0.0.0.0')) {
    return configuredBaseUrl.replace('http://0.0.0.0', 'http://127.0.0.1')
  }

  return configuredBaseUrl
}
